module.exports = __webpack_public_path__ + "static/media/007-emoji-5.bce964bf.svg";